﻿<script>
	import { Router, Route, navigate } from "svelte-navigator";

    import { endSurveyPageIndex, pageList, currentPage } from "../stores/pageStore";
    import surveyPages from "./surveyPages";

    import PageTracker from "../components/PageTracker.svelte"

    export let url = "";
	export let basepath = "/";

    if (window.location.pathname !== surveyPages[0].routeId && window.location.pathname.indexOf("Review") < 0) {
        navigate(surveyPages[0].routeId + window.location.search);
    }
    $pageList = surveyPages;
    $endSurveyPageIndex = surveyPages.find(p => p.endSurvey).pageIndex;

</script>


<div class="container">
	<Router {url} {basepath}>
        <section>
            {#if !$currentPage.hidePage}
                <PageTracker />

                {#each $pageList as page}
			        <Route path="{page.routeId}" primary={false}>
                        <svelte:component this={page.component} {...page.params} />
			        </Route>
                {/each}
            {/if}
        </section>
	</Router>
</div>

<style>
    .container {
        padding: 40px;
    }
</style>

